import styled from "styled-components";
import { theme } from "ui/themes";

interface ColumnTableProps {
  color?: string;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FlexCenterRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  gap: 2rem;
  margin-top: 3rem;
  height: 2rem;
  margin-bottom: 2rem;
`;

export const BoxMain = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${theme.device.desktopFirst.laptop} {
    gap: 0.5rem;
    flex-direction: column;
    align-items: start;
  }
`;

export const TextDescription = styled.span`
  flex: 0.58;
  font-size: 1.4rem;
  font-weight: ${theme.typography.fontWeight["600"]};
  max-width: 12rem;
`;

export const BoxInfo = styled.div`
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

// artur.castro, solućão feia, o correto deve ser corrigir como está sendo utilizado os componentes estilizados atualmente
export const TitleColumnTableWrapper = styled.div`
  padding-right: 1.75rem;
`;

export const TitleColumnTable = styled.th`
  color: ${theme.colors.neutral["999"]};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 1.15rem;
`;

export const ColumnTable = styled.td<ColumnTableProps>`
  font-weight: ${theme.typography.fontWeight["600"]};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 1.15rem;
  max-width: 6rem;
  color: ${({ color }) => color || theme.colors.neutral["999"]};
`;

export const TitleInvalidZipCode = styled.h6`
  margin-top: 2rem;
  color: ${theme.colors.primary["300"]};
  font-weight: 500;
  font-size: 1.4rem;
  margin-bottom: 0.5rem;
`;
export const TextInvalidZipCode = styled.p`
  color: ${theme.colors.neutral["520"]};
  font-weight: 400;
  font-size: 1.2rem;
`;

export const ShippingConditionsTexts = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  margin-top: 0.5rem;
`;

export const ConditionText = styled.p`
  color: ${theme.colors.neutral["585"]};
  font-weight: 400;
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: ${theme.typography.fontSize.sm.x1};
  line-height: 120%;

  @media ${theme.device.desktopFirst.tablet} {
    font-size: ${theme.typography.fontSize.sm.x3};
    line-height: 120%;
  }
`;
